import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ReportAllRecordsImage } from './models/template.model';

@Injectable()
export class ReportImagesService {
  private readonly _onUpdateAdditionalImage = signal<any>({});
  readonly onUpdateAdditionalImage$ = toObservable(this._onUpdateAdditionalImage);

  /**
   * @param reportImages type of @ReportAllRecordsImage that contains the record with with additional image id's.
   * which will trigger when there is change in particular record like add/ edit/ delete.
   */
  setReportRecordImages(reportImages: ReportAllRecordsImage) {
    this._onUpdateAdditionalImage.set({ ...reportImages });
  }
}
